module.exports = __webpack_public_path__ + "images/logo-muenchen-bildung-sport-14e5b464a8f52ea877e626893fbd06a7.png";